/**
 * Content of the signing help modal, kept apart from the component so it can be updated without
 * touching any rendering code. Transcribed verbatim from "INSTRUÇÕES - Assinar PRESCRIÇÕES
 * PENDENTES (Atualização Setembro 2026)" — keep it that way, the wording is owned by the document.
 *
 * Shape:
 *   intro     — leading paragraphs
 *   sections  — each has a title and a list of groups; a group is an optional title plus its items
 *   callouts  — highlighted boxes shown after the sections
 *
 * Text wrapped in **double asterisks** is rendered bold, mirroring the bold runs of the document,
 * and [text](url) becomes an external link. The two combine as **[text](url)**.
 * Titles are bold by style, so they carry no markers.
 */
const SIGNING_HELP_CONTENT = Object.freeze({
  title: 'Como Assinar e Finalizar a sua Prescrição',
  intro: [
    'Ao selecionar “**Cartão | Mais tarde**”, durante a emissão de uma receita, esta ficará guardada como "pendente". Poderá retomar a assinatura em qualquer altura, tanto nesta versão web como na aplicação móvel.',
    'Para concluir uma prescrição, confirme a informação de cada linha e clique em **“Finalizar”**. Escolha depois uma das seguintes opções para assinar:'
  ],
  sections: [
    {
      title: 'Opção 1: Assinar com Chave Móvel Digital (CMD)',
      groups: [
        {
          items: [
            'Selecione “**Assinar com CMD**”;',
            'Preencha o seu número de telefone e o seu PIN de assinatura;',
            'Introduza o código OTP (SMS/Notificação da aplicação [GOV.PT](http://gov.pt)) que receber no seu telemóvel.'
          ]
        }
      ],
      note: 'Nota: Pode consultar o seu saldo de assinaturas disponíveis no contador junto ao botão do Menu.'
    },
    {
      title: 'Opção 2: Assinar com Cartão de Cidadão (CC)',
      groups: [
        {
          title: 'Antes de começar, garanta que tem instalado no computador:',
          items: [
            'A [Aplicação Autenticação.gov](https://www.autenticacao.gov.pt/cc-aplicacao) (da responsabilidade da **[ARTE, I.P.](https://www.arte.gov.pt/)**);',
            'O software **e-ID Signer** (links de instalação para macOS e Windows disponíveis no Menu desta página).'
          ]
        },
        {
          title: 'Passo a passo para assinar:',
          items: [
            'Abra o software **e-ID Signer** no seu computador;',
            'Ligue o leitor de cartões à porta USB e insira o seu **Cartão de Cidadão**;',
            'Confirme no topo do ecrã se o estado mudou de “Software de Leitura Indisponível” para **“Pronto Para Assinar”**;',
            'Selecione a opção de assinatura por CC e introduza o seu **PIN de assinatura**, na janela que se abre para o efeito.'
          ]
        }
      ]
    }
  ],
  callouts: [
    {
      title: '💡 Dica de Resolução de Problemas:',
      text: 'Se o estado não avançar para "Pronto Para Assinar": retire o CC do leitor ➔ feche o **e-ID Signer** ➔ desligue o leitor USB. Depois, volte a abrir o software, ligue o leitor e insira o cartão (esta ordem exata).'
    },
    {
      title: 'Informação Útil:',
      text: 'Nesta versão web da Scribo, pode também alterar ou adicionar novos destinatários para o envio do Guia de Tratamento da sua receita.'
    }
  ]
})

export default SIGNING_HELP_CONTENT
